import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: '10', label: 'Further Education or Training' },
    { value: '11', label: 'Employment and further education/training' },
    { value: '12', label: 'Employment' },
    { value: '13', label: 'Other' },
    { value: '88', label: 'Unknown' },
  ],
});
